import React from 'react';
import { IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';
import { useHistory } from 'react-router';

import { EquipmentModel } from '@app/api/models';
import { entityBaseBodyRender, TableColumn } from '@app/components/common/table';

export type ColumnsOptions = {
  type: EntityBase[];
};

export const useColumns = (): TableColumn<EquipmentModel>[] => {
  const history = useHistory();

  const columns: TableColumn<EquipmentModel>[] = [
    {
      name: 'id',
      label: '#',
      options: {
        filter: true,
        sort: true,
      },
    },
    // {
    //   name: 'type',
    //   label: 'Тип',
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: entityBaseBodyRender(),
    //     ...getGuideSelectFilter('type_id', 'equipment_type', 'Тип'),
    //   },
    // },
    {
      name: 'name',
      label: 'Название',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'manufacturer',
      label: 'Производитель',
      options: {
        filter: {
          name: 'manufacturer_id',
          sourceName: 'equipment_manufacturer',
          type: 'multi-select',
        },
        sort: true,
        customBodyRender: entityBaseBodyRender(),
      },
    },
    {
      name: 'on_balance',
      label: 'На балансе',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'id',
      label: 'Изм.',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id) => (
          <IconButton
            icon={<MdEdit />}
            onClick={() => history.push('/equipments-guide/edit/' + id)} 
            aria-label='edit'     
          />
        ),
      },
    },
  ];

  return columns;
};
